export const environment = {
  appVersion                : 'v' + require('../../package.json').version + '-dev',
  production                : false,

  javaServerUrl             : 'https://api.kiwiplans.com/',
  nodeServerUrl             : 'https://api.kiwiplans.com:7002',
  insuranceServerUrl        : 'https://api.kiwiplans.com:7001',
  qaJavaServerUrl           : 'https://qa-backend.kiwiplans.com/',
  thorJavaServerUrl         : 'https://thor.kiwiplans.com/',
  nodeServerPort            : 7002,

  oldWebPortalUrl           : 'https://www.kiwiplans.com/apps/',
  redirectionUrl            : 'https://www.kiwiplans.com/webApp/',

  basic_auth_key            : 'Basic d2ViOnNlY3JldEtleQ==',
  googleMaps_api_key        : 'AIzaSyDmeYq89gbRh3xPgbUtNN7CHY6GXdvJmA8',

  firebaseConfig            : {
    apiKey            : "AIzaSyAoz5NSlByFb4EctZo2hyCer_VhYGW7sQU",
    authDomain        : "merchantsaasangular.firebaseapp.com",
    projectId         : "merchantsaasangular",
    storageBucket     : "merchantsaasangular.appspot.com",
    messagingSenderId : "670293225500",
    appId             : "1:670293225500:web:cb53e5c92d96ad30c0efd9",
    measurementId     : "G-VNT2J8SFRH",
  },

  defaultGoogleMapsCoords: {
    latitude  : 28.481267522231487,
    longitude : 77.08508891081465
  },

// ------------ Size in 'MB' ------------- //
  max_img_upload_size       : 4,
  max_file_upload_size      : 5,
  max_img_compression_size  : 3.5,
// --------------------------------------- //

// ----------- Size in 'BYTES' ----------- //
  file_part_chunk_size  : 2000,
// --------------------------------------- //
}
